export default __webpack_public_path__ + "static/media/hostIntelligence.f5d8d6fd.png";